import {
    button, buttonText,
} from 'components/Button/styles/ButtonView'

import {
    messageContainer,
    messageTime,
    nameText,
    speechBubble,
    speechBubbleContainer,
} from 'components/Messages/ChannelMessage/styles/ChannelMessage'

import {styled} from 'stitches/config'

const UIMessageBox = styled('div', {
    defaultVariants: {
        direction: 'row',
        gap: 'none',
        padding: 'none',
    },
    display: 'flex',
    flexWrap: 'wrap',
    variants: {
        alignCenter: {true: {alignItems: 'center'}},
        direction: {
            column: {flexDirection: 'column'},
            row: {flexDirection: 'row'},
        },
        gap: {
            none: {gap: 0},
            small: {gap: '0.7em'},
            smaller: {gap: '0.3em'},
        },
        justifyEnd: {true: {justifyContent: 'flex-end'}},
        padding: {
            none: {padding: 0},
            small: {padding: '0.5em 0'},
            smaller: {padding: '0.2em 0'},
        },
    },
})

export const StyledMessageContainer = styled('div', messageContainer)
export const StyledSpeechBubbleContainer = styled('div', speechBubbleContainer)
export const StyledName = styled('span', nameText)
export const StyledSpeechBubble = styled('div', speechBubble)

export const StyledMessageContent = styled(UIMessageBox, {
    defaultVariants: {
        direction: 'column',
        gap: 'small',
        padding: 'smaller',
    },
    width: '100%',
})

export const StyledSelectButtonWrapper = styled(UIMessageBox, {
    defaultVariants: {
        direction: 'row',
        gap: 'smaller',
    },
})

export const StyledSelectLinkWrapper = styled(UIMessageBox, {
    defaultVariants: {
        direction: 'row',
        gap: 'smaller',
    },
})

export const StyledSelectContainer = styled(UIMessageBox, {
    defaultVariants: {
        direction: 'column',
        gap: 'small',
    },
})

export const StyledSendButtonContainer = styled(UIMessageBox, {
    defaultVariants: {
        direction: 'row',
        justifyEnd: true,
    },
})

export const StyledActionMessageContent = styled(UIMessageBox, {
    defaultVariants: {
        alignCenter: true,
        direction: 'row',
        gap: 'small',
    },
})

export const StyledActionName = styled(UIMessageBox, {
    '& span': {
        color: '$messageText',
        fontStyle: 'italic',
    },
    '& svg': {color: '$messageInfoIcon'},
    'defaultVariants': {
        alignCenter: true,
        direction: 'row',
        gap: 'small',
    },
})

export const StyledSelectButtonLabel = styled('div', {fontWeight: '$labelText'})

export const StyledSelectButtonOptions = styled(UIMessageBox, {
    defaultVariants: {
        direction: 'row',
        gap: 'smaller',
    },
})

export const StyledActionLabel = styled('span', {color: '$messageText'})

export const StyledTime = styled('time', messageTime)


export const link = {
    ...button,
    '&&': {
        display: 'flex',
        justifyContent: 'space-between',
        textDecoration: 'none',
    },
}

export const linkText = {...buttonText}
